import React, { Fragment } from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";

import {
  FullLayout,
  EmptyLayout,
  E404Page,
  LoginPage,
  QuickLoginPage,
  HomePage,
  HomeTvPage,
  HomeTv2Page,
  HomeTvSubmissionsPage,
  InvitationPage,
  AdminPage,
  ChatPage,
  LogsListPage,
  ClientListPage,
  ClientPage,
  DashboardPage,
  DataSubmissionsPage,
  DocumentListPage,
  DocumentCreatePage,
  IncidentListPage,
  IncidentPage,
  NoteListPage,
  NotePage,
  SseListPage,
  SsePage,
  SseVisitorPage,
  ProjectListPage,
  ProjectPage,
  TailgateListPage,
  TailgatePage,
  SubmissionListPage,
  SubmissionPage,
  UserListPage,
  UserPage,
  PowerBiPage,
} from "pages";

import { connect } from "react-redux";
import { userActions } from "actions";

import { history } from "utils/history";

import { USER_RANK_NULL, NOTE_TYPE_SSE } from "constants/dbValues";
import { ABILITIES } from "constants/abilities";
import { AbilityContext, Can } from "constants/abilityContext";
import SubmissionsList from "components/SubmissionsList";

class AppRouter extends React.Component {
  getAbilities() {
    return this.props.rank ? ABILITIES[this.props.rank] || ABILITIES.default : {};
  }

  render() {
    let { mode, logged } = this.props;
    const AppRoute = ({
      component: Component,
      layout: Layout,
      componentProps,
      layoutProps,
      ...rest
    }) => {
      return (
        <Route
          {...rest}
          render={(matchProps) => (
            <Layout {...layoutProps}>
              <Component {...componentProps} {...matchProps} />
            </Layout>
          )}
        />
      );
    };
    var routes = logged ? (
      <AbilityContext.Provider value={this.getAbilities()}>
        {mode === "admin" ? (
          <Switch>
            <AppRoute layout={FullLayout} exact path="/" component={HomePage} />
            <AppRoute layout={EmptyLayout} exact path="/tv" component={HomeTvPage} />
            <AppRoute layout={EmptyLayout} exact path="/tv2" component={HomeTv2Page} />
            <AppRoute
              layout={EmptyLayout}
              exact
              path="/tv-soumissions"
              component={HomeTvSubmissionsPage}
            />
            <AppRoute layout={FullLayout} exact path="/options" component={AdminPage} />
            <AppRoute layout={FullLayout} exact path="/chat" component={ChatPage} />

            <AppRoute layout={FullLayout} exact path="/powerbi" component={PowerBiPage} />

            <AppRoute layout={FullLayout} exact path="/clients" component={ClientListPage} />
            <AppRoute
              layout={FullLayout}
              exact
              path="/clients/create"
              component={(props) => <ClientPage {...props} create />}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/clients/:id/edit"
              component={(props) => <ClientPage {...props} edit />}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/clients/:id"
              component={(props) => <ClientPage {...props} key={props.match.params.id} />}
            />

            <AppRoute layout={FullLayout} exact path="/dashboard" component={DashboardPage} />

            <AppRoute layout={FullLayout} exact path="/documents" component={DocumentListPage} />
            <AppRoute
              layout={FullLayout}
              exact
              path="/documents/:type/:id"
              component={(props) => <DocumentListPage {...props} gallery />}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/documents/create"
              component={(props) => <DocumentCreatePage {...props} create full />}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/documents/:model/:target/:type/create"
              component={(props) => <DocumentCreatePage {...props} create single />}
            />

            <AppRoute layout={FullLayout} exact path="/incidents" component={IncidentListPage} />
            <AppRoute
              layout={FullLayout}
              exact
              path="/incidents/create"
              component={(props) => <IncidentPage {...props} create />}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/incidents/:id/edit"
              component={(props) => <IncidentPage {...props} edit />}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/incidents/:id"
              component={(props) => <IncidentPage {...props} key={props.match.params.id} />}
            />

            <AppRoute layout={FullLayout} exact path="/notes" component={NoteListPage} />
            <AppRoute
              layout={FullLayout}
              exact
              path="/notes/create"
              component={(props) => <NotePage {...props} create />}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/notes/:id/edit"
              component={(props) => <NotePage {...props} edit />}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/notes/:id"
              component={(props) => <NotePage {...props} key={props.match.params.id} />}
            />

            <AppRoute
              layout={FullLayout}
              exact
              path="/sse"
              component={(props) => <SseListPage {...props} type={NOTE_TYPE_SSE} />}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/sse/create"
              component={(props) => <SsePage {...props} type={NOTE_TYPE_SSE} create />}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/sse/create/visitor"
              component={(props) => <SsePage {...props} type={NOTE_TYPE_SSE} create />}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/sse/:id/edit"
              component={(props) => <SsePage {...props} type={NOTE_TYPE_SSE} edit />}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/sse/:id"
              component={(props) => (
                <SsePage {...props} type={NOTE_TYPE_SSE} key={props.match.params.id} />
              )}
            />

            <AppRoute layout={FullLayout} exact path="/projects" component={ProjectListPage} />
            <AppRoute
              layout={FullLayout}
              exact
              path="/projects/create"
              component={(props) => <ProjectPage {...props} create />}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/projects/:id/edit"
              component={(props) => <ProjectPage {...props} edit />}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/projects/:id"
              component={(props) => <ProjectPage {...props} key={props.match.params.id} />}
            />

            <AppRoute layout={FullLayout} exact path="/logs" component={LogsListPage} />

            <AppRoute layout={FullLayout} exact path="/tailgates" component={TailgateListPage} />
            <AppRoute
              layout={FullLayout}
              exact
              path="/tailgates/create"
              component={(props) => <TailgatePage {...props} create />}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/tailgates/:id/edit"
              component={(props) => <TailgatePage {...props} edit />}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/tailgates/:id"
              component={(props) => <TailgatePage {...props} key={props.match.params.id} />}
            />

            <AppRoute
              layout={FullLayout}
              exact
              path="/submissions"
              component={SubmissionListPage}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/dashboardsoumissions"
              component={SubmissionsList}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/data-soumissions"
              component={DataSubmissionsPage}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/submissions/create"
              component={(props) => <SubmissionPage {...props} create />}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/submissions/:id/edit"
              component={(props) => <SubmissionPage {...props} edit />}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/submissions/:id"
              component={(props) => <SubmissionPage {...props} key={props.match.params.id} />}
            />

            <AppRoute layout={FullLayout} exact path="/users" component={UserListPage} />
            <AppRoute
              layout={FullLayout}
              exact
              path="/users/create"
              component={(props) => <UserPage {...props} create />}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/users/:id/edit"
              component={(props) => <UserPage {...props} edit />}
            />
            <AppRoute
              layout={FullLayout}
              exact
              path="/users/:id"
              component={(props) => <UserPage {...props} key={props.match.params.id} />}
            />

            <Redirect from="/login" to="/" />

            <AppRoute
              layout={EmptyLayout}
              exact
              path="/invitation/:enc_submission"
              component={InvitationPage}
            />
            <AppRoute layout={FullLayout} component={E404Page} />
          </Switch>
        ) : (
          <Switch>
            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/"
              component={HomePage}
            />
            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/chat"
              component={ChatPage}
            />

            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/tailgates/create"
              component={(props) => <TailgatePage {...props} create />}
            />
            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/incidents/create"
              component={(props) => <IncidentPage {...props} create />}
            />
            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/sse/create"
              component={(props) => <SsePage {...props} type={NOTE_TYPE_SSE} create />}
            />
            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/sse/create/visitor"
              component={(props) => <SsePage {...props} type={NOTE_TYPE_SSE} create />}
            />
            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/notes/create"
              component={(props) => <NotePage {...props} create />}
            />

            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/documents"
              component={(props) => <DocumentListPage {...props} gallery galleryOnly />}
            />
            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/documents/create"
              component={(props) => <DocumentCreatePage {...props} create />}
            />
            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/documents/create/:model"
              component={(props) => <DocumentCreatePage {...props} create />}
            />
            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/documents/create/:model/:target"
              component={(props) => <DocumentCreatePage {...props} create />}
            />

            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/logs"
              component={LogsListPage}
            />

            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/projects"
              component={(props) => <ProjectListPage {...props} cards />}
            />
            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/projects/:id"
              component={(props) => <ProjectPage {...props} key={props.match.params.id} />}
            />
            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/clients/:id"
              component={(props) => <ClientPage {...props} key={props.match.params.id} />}
            />
            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/tailgates/:id"
              component={(props) => <TailgatePage {...props} key={props.match.params.id} />}
            />
            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/incidents/:id"
              component={(props) => <IncidentPage {...props} key={props.match.params.id} />}
            />
            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/sse"
              component={(props) => <SseListPage {...props} type={NOTE_TYPE_SSE} />}
            />
            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/sse/:id"
              component={(props) => (
                <SsePage {...props} type={NOTE_TYPE_SSE} key={props.match.params.id} />
              )}
            />
            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/notes/:id"
              component={(props) => <NotePage {...props} key={props.match.params.id} />}
            />
            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/users/:id"
              component={(props) => <UserPage {...props} key={props.match.params.id} />}
            />

            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              exact
              path="/tailgates/:id/edit"
              component={(props) => <TailgatePage {...props} key={props.match.params.id} edit />}
            />

            <Redirect from="/login" to="/" />

            <AppRoute
              layout={EmptyLayout}
              exact
              path="/invitation/:enc_submission"
              component={InvitationPage}
            />
            <AppRoute
              layout={EmptyLayout}
              exact
              path="/invitations/:enc_submission"
              component={InvitationPage}
            />
            <AppRoute
              layout={FullLayout}
              layoutProps={{ consultation: true }}
              component={E404Page}
            />
          </Switch>
        )}
      </AbilityContext.Provider>
    ) : (
      <Fragment>
        <Switch>
          <AppRoute
            layout={EmptyLayout}
            exact
            path="/invitation/:enc_submission"
            component={InvitationPage}
          />
          <AppRoute
            layout={EmptyLayout}
            exact
            path="/invitations/:enc_submission"
            component={InvitationPage}
          />
          <AppRoute
            layout={EmptyLayout}
            exact
            path="/sse/create/visitor"
            component={(props) => <SseVisitorPage {...props} type={NOTE_TYPE_SSE} create />}
          />
          {process.env.NODE_ENV === "development" && (
            <AppRoute layout={EmptyLayout} exact path="/quick-login" component={QuickLoginPage} />
          )}
          <AppRoute layout={EmptyLayout} component={LoginPage} />
        </Switch>
      </Fragment>
    );

    return <Router history={history}>{routes}</Router>;
  }
}

const mapStateToProps = (state) => {
  return {
    logged: state.user.logged,
    mode: state.user.viewMode,
    rank: state.user.logged ? (state.user.infos.user_type || {}).rang : USER_RANK_NULL,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setViewMode: (mode) => dispatch(userActions.updateViewMode(mode)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppRouter);
